import { FC, PropsWithChildren, useLayoutEffect, useRef } from 'react';

import { useAuth } from '@workos-inc/authkit-react';

import { setApiAccessTokenGetter } from '@/api/api';

export const AuthTokenSync: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { user, getAccessToken } = useAuth();
  const getAccessTokenRef = useRef(getAccessToken);
  getAccessTokenRef.current = getAccessToken;

  useLayoutEffect(() => {
    // Sync registration before paint so the first axios request already has a token getter.
    // Stable wrapper + ref: each request calls the latest WorkOS getAccessToken, not a stale render closure.
    setApiAccessTokenGetter(user ? () => getAccessTokenRef.current() : null);
    return () => {
      setApiAccessTokenGetter(null);
    };
  }, [user]);

  if (!user) {
    return null;
  }

  return <>{children}</>;
};
